import '@tencent/exeditor3-ui-kit/dist/toolbar-button.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
import { styles } from './styles.js';
export class FullscreenPlugin {
    constructor(opt = {}) {
        this.name = 'fullscreen';
        this.isFullscreen = false;
        this.config = {};
        this.originZIndex = '';
        this.originContainer = null;
        this.hooks = {};
        this.toggle = (toStatus) => {
            var _a, _b, _c;
            const status = toStatus === undefined ? !this.isFullscreen : toStatus;
            if (status) {
                document.body.classList.add('ex-lockscroll');
                const container = this.findContainer();
                if (container) {
                    this.originContainer = container;
                    container.classList.add('ex-fullscreen');
                    this.originZIndex = container.style.zIndex;
                    container.style.zIndex = ((_a = this.config.zIndex) === null || _a === void 0 ? void 0 : _a.toString()) || '1';
                }
            }
            else {
                const container = this.originContainer;
                if (container) {
                    container.style.zIndex = this.originZIndex;
                    this.originZIndex = '';
                    container.classList.remove('ex-fullscreen');
                    this.originContainer = null;
                }
                document.body.classList.remove('ex-lockscroll');
            }
            this.isFullscreen = status;
            (_c = (_b = this.hooks).afterToggle) === null || _c === void 0 ? void 0 : _c.call(_b, status);
        };
        const { afterToggle, ...config } = opt;
        this.hooks = {
            afterToggle: opt.afterToggle,
        };
        this.config = config;
    }
    initEditor(editor) {
        this.editor = editor;
        this.editor.on('beforedestroy', () => {
            this.toggle(false);
        });
    }
    capabilities() {
        return {
            styles,
            commands: {},
            shortcuts: {
                'Mod-Shift-f': () => this.toggle(),
            },
        };
    }
    renderToolbarItem() {
        const btn = document.createElement('exeditor-toolbar-button');
        Object.assign(btn, {
            label: '全屏',
            shortcut: 'Mod-Shift-f',
            onclick: () => {
                const status = !this.isFullscreen;
                this.toggle(status);
                btn.label = !status ? '全屏' : '退出全屏';
            },
        });
        btn.appendChild(createIcon({
            name: this.name,
            editor: this.editor,
            fallback: () => import('./icon.js').then((m) => m.fullscreenIcon),
        }));
        return btn;
    }
    findContainer() {
        let container;
        const selector = this.config.container;
        if (typeof selector === 'string') {
            container = document.querySelector(selector);
        }
        if (selector instanceof HTMLElement) {
            container = selector;
        }
        if (!container) {
            const root = this.editor.getRootDOM();
            const toolbarRoot = this.editor.getToolbarRootDOM();
            container = findCommonAncstorNode(root, toolbarRoot);
        }
        return container;
    }
}
function findCommonAncstorNode(nodeA, nodeB) {
    if (!nodeB) {
        return nodeA.parentElement;
    }
    const pathA = getNodePath(nodeA).reverse();
    const pathB = getNodePath(nodeB).reverse();
    const path = findCommonPath([pathA, pathB]);
    const commonNode = path[path.length - 1];
    return commonNode;
}
function getNodePath(node, path = []) {
    if (node === document.body) {
        return path;
    }
    const parent = node.parentElement;
    if (parent) {
        return getNodePath(parent, path.concat(parent));
    }
    return path;
}
function findCommonPath(paths) {
    let i = 0;
    const len = Math.min(...paths.map((p) => p.length));
    while (i < len) {
        const target = paths[0][i];
        const isEqual = paths.every((p) => p[i] === target);
        if (!isEqual) {
            break;
        }
        i++;
    }
    return paths[0].slice(0, i);
}
//# sourceMappingURL=index.js.map